// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f034756d","977":"b9590c10"}[chunkId] + ".chunk.js";
};